/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createOct } from '../../factoriesAny.js';
export var octDependencies = {
  typedDependencies,
  createOct
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesOct.generated.js
// module id = null
// module chunks = 